import { ConCludeBorrowComponent } from "../../../components/borrowSystem/Report/ConCludeBorrowComponent";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function ConCludeBorrowContainer() {
  const titleName = " สรุปข้อมูลการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน"; //ใส่ชื่อtitle ตรงนี้
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <ConCludeBorrowComponent />
      <Footer />
    </div>
  );
}
